import React from 'react';
import SkylineRoleDropdown, { SkylineRoleDropdownQuery } from './SkylineRoleDropdown';
import ForecastQueryRenderer from '../../../../../../ForecastQueryRenderer';
const SkylineRoleDropdownRelayWrapper = ({ role, onSelect, controlled, projectId, }) => {
    return (React.createElement(ForecastQueryRenderer, { key: "query-render-skyline-role-dropdown", query: SkylineRoleDropdownQuery, variables: { projectId: projectId }, render: relayProps => {
            return (React.createElement(SkylineRoleDropdown, Object.assign({}, relayProps, { role: role, onSelect: onSelect, controlled: controlled, projectId: projectId })));
        } }));
};
export default SkylineRoleDropdownRelayWrapper;
